// File Location: src/services/firebaseConfig.js

import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyD4nIhEo5CsgHQaPXVtpOl7udp7nm2QoWY",
  authDomain: "otpfirebaseproject-70f8b.firebaseapp.com",
  databaseURL: "https://otpfirebaseproject-70f8b.firebaseio.com",
  projectId: "otpfirebaseproject-70f8b",
  storageBucket: "otpfirebaseproject-70f8b.appspot.com",
  messagingSenderId: "376076841719",
  appId: "1:376076841719:web:cfd576ef00e705172ad9f2",
  measurementId: "G-GQ7JP7TB46",
};

// Initialize Firebase (guard for hot-reload environments)
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// Initialize a secondary app for privileged operations (e.g., creating users)
const secondaryApp = getApps().find(a => a.name === 'Secondary') || initializeApp(firebaseConfig, 'Secondary');

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
export const secondaryAuth = getAuth(secondaryApp);

export default app;
